export function normalizeJSDelivr(files, fileObject = {}) {
    for (let i = 0; i < files.length; i += 1) {
        fileObject[files[i].name] = true; // eslint-disable-line no-param-reassign
    }
    return fileObject;
}
